(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const forms = document.querySelectorAll('.email-signup__form');

    const showToast = (form, message) => {
      const toast = form.querySelector('[data-email-signup-toast]');
      if (!toast) return;

      toast.textContent = message;
      toast.setAttribute('aria-hidden', 'false');
      toast.classList.add('is-visible');

      window.clearTimeout(toast.hideTimer);
      toast.hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
      }, 4200);
    };

    forms.forEach((form) => {
      if (form.querySelector('[data-email-signup-success]')) {
        showToast(form, 'Thanks for joining. EGGI will keep you posted.');
      }

      if (form.querySelector('[data-email-signup-error]')) {
        showToast(form, 'Please check your email address and try again.');
      }

      form.addEventListener('submit', () => {
        if (!form.checkValidity()) {
          showToast(form, 'Please enter a valid email address.');
          return;
        }

        showToast(form, 'Saving your spot...');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
